<template>
  <Detail
    :title="title('web.new_server')"
    @submit="submit">

    <template slot="header-controls">
      <vk-icon-button
        icon="check"
        type="submit"
        :tooltip="tooltip('generic.save')"
      />
      <ConfirmModal
        :title="$t('web.confirm_delete_server_title')"
        :message="$t('web.confirm_delete_server_message')"
        @confirm="deleteServer">
        <vk-icon-button
          icon="trash"
          type="button"
          v-if="!isCreateMode"
          class="uk-margin-small-left"
          :tooltip="tooltip('generic.delete')"
        />
      </ConfirmModal>
    </template>

    <vk-tabs>
      <vk-tabs-item :title="$t('generic.general')">
        <vk-grid class="uk-margin-top">
          <labeled-input
            required
            v-model="model.name"
            class="uk-width-1-1@s">
            {{ $t('generic.name') }}
          </labeled-input>

          <labeled-input
            type="select"
            :values="customerValues"
            v-model="model.customer_id"
            class="uk-width-1-2@s uk-margin-small">
            {{ $t('generic.customer') }}
          </labeled-input>

          <labeled-input
            v-model="model.hostname"
            class="uk-width-1-2@s uk-margin-small">
            {{ $t('web.servers.hostname') }}
          </labeled-input>

          <labeled-input
            v-model="model.ipv4"
            class="uk-width-1-2@s uk-margin-small">
            {{ $t('web.servers.ipv4') }}
          </labeled-input>

          <labeled-input
            type="select"
            :values="providerValues"
            v-model="model.provider_id"
            class="uk-width-1-2@s uk-margin-small">
            {{ $t('generic.provider') }}
          </labeled-input>

          <labeled-input
            v-model="model.ipv6"
            class="uk-width-1-1@s uk-margin-small">
            {{ $t('web.servers.ipv6') }}
          </labeled-input>

          <labeled-input
            type="textarea"
            v-model="model.comment"
            class="uk-width-1-1@s uk-margin-small">
            {{ $t('generic.note') }}
          </labeled-input>
        </vk-grid>
      </vk-tabs-item>

      <!-- Seiten -->
      <vk-tabs-item
        :icon="tabIcon"
        :title="$t('nav.pages')"
        :disabled="isCreateMode">
        <Pages
          query-param="pageId"
          :foreign-values="pageValues"
        />
      </vk-tabs-item>
    </vk-tabs>
  </Detail>
</template>

<script>
  import {mapGetters} from 'vuex'
  import DetailMixin from '../../mixins/detail'
  import Detail from '../../components/layout/details/Detail'
  import Pages from '../../components/layout/details/references/Pages'
  import VkIconButton from '../../components/global/vuikit/VkIconButton'
  import LabeledInput from '../../components/global/inputs/LabeledInput'
  import ConfirmModal from '../../components/global/modals/ConfirmModal'

  export default {
    computed: {
      ...mapGetters({
        customers: 'customer/customers',
        providers: 'web/providers',
        pages: 'web/pages',
      }),
      customerValues() {
        return [{id: null, name: this.$t('customers.no_customer')}].concat(this.customers)
      },
      providerValues() {
        return [{id: null, name: this.$t('web.no_provider')}].concat(this.providers)
      },
      pageValues() {
        return this.pages.filter(page => page.server_id === this.$route.params[this.routeParam]
          || page.server_id === this.$route.query[this.routeParam])
      }
    },
    created() {
      this.setup(
        'serverId',
        'web/serverById',
      'web.server_created',
      'web.server_updated',
      'web.server_deleted')

      // Prefill form
      if (this.isCreateMode) {
        if (this.$route.params.providerId) {
          this.model.provider_id = this.$route.params.providerId
        }

        if (this.$route.params.customerId) {
          this.model.customer_id = this.$route.params.customerId
        }
      }

      // Loading referencing models
      this.prefetchData([
        'customer/loadCustomers',
        'web/loadProviders',
        'web/loadPages'
      ])
    },
    methods: {
      submit() {
        return this.saveModel('web/saveServer').then(() => {
          if (this.isCreateMode) {
            if (this.isViewCalledByQueryParam) {
              return this.$router.push({query: {[this.routeParam]: this.model.id}})
            }
            this.$router.push('/' + this.$i18n.locale + '/' + this.$route.params.appId + '/servers/' + this.model.id)
          }
        })
      },
      deleteServer() {
        return this.deleteModel('web/deleteServer').then((res) => {
          if (res && res.success) {
            this.$router.push('/' + this.$i18n.locale + '/' + this.$route.params.appId + '/servers')
          }
        })
      }
    },
    mixins: [
      DetailMixin
    ],
    components: {
      ConfirmModal,
      VkIconButton,
      LabeledInput,
      Detail,
      Pages
    }
  }
</script>